const Backgrid = require('backgrid');
const _ = require('underscore');
const Backbone = require('backbone');
(function(window, $, _, Backbone, Backgrid) {
    var ViewCell = (Backgrid.ViewCell = Backgrid.Cell.extend({
        render: function() {
            this.$el.empty();
            var ViewModule = this.column.get('view_module');

            var customViewOptions = this.column.get('viewOptions');
            if (_.isFunction(customViewOptions)) {
                customViewOptions = customViewOptions.apply(this);
            }
            var viewOptions = _.extend(
                {
                    model: this.model,
                    data: this.column.get('data'),
                    columnName: this.column.get('name'),
                    formatter: this.column.get('formatter')
                },
                customViewOptions
            );
            this.view = new ViewModule(viewOptions);

            this.$el.append(this.view.render().el);
            if (this.column.get('align')) {
                this.$el.css('text-align', this.column.get('align'));
            }
            if (this.column.has('classNames') && this.column.get('classNames').length) {
                this.$el.addClass(this.column.get('classNames').join(' '));
            }
            this.delegateEvents();

            // Wait for the grid to actually be in the dom
            if (this.column.get('reRender')) {
                this.listenTo(this.model.collection, 'grid-rendered', function() {
                    this.view.render();
                });
            }

            // Handle Change Events
            if (this.column.get('editable')) {
                this.listenTo(this.view, 'change', function(newData) {
                    this.model.set(viewOptions.columnName, newData);
                });
            }
            return this;
        },

        /** @property */
        className: 'view-cell',

        remove: function() {
            this.view.close();
            Backgrid.Cell.prototype.remove.apply(this, arguments);
        }
    }));
})(window, jQuery, _, Backbone, Backgrid);
